module Meevo.Plugins.ServicesWizard {

    class MeevoServicesTabComponent implements ng.IComponentController {

        static $inject = [
            'meevo.plugins.servicesWizard.ServicesWizardService',
            'meevo.components.busy.BusyService',
            '$q'
        ];


      //  public selectedSecurityFeature: IntDetail;
        public serviceList: any;
        public isEditing:boolean;
        constructor(protected servicesWizardService: IServicesWizardService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $q: angular.IQService) {
            this.isEditing = false;
            this.servicesWizardService.selectedServiceCatList = [];
        }

        $onInit() {
            //this.serviceList = this.servicesWizardService.serviceList;
            //    this.loadServiceSList("");
        }

        isServiceAlreadyImported(item: any): boolean {

            return item.matchDN_Service_TId || item.matchExt_Service_TId || item.matchSC_Service_TId;

        }

        checkedServicesClick(item: any, categoryFilter:any): void {
           if (Model.Guard.isNothing(this.servicesWizardService.selectedServiceList)) {
                this.servicesWizardService.selectedServiceList = [];
            }
           if (item.isChecked && categoryFilter==1) {
                this.servicesWizardService.selectedServiceList.push({
                    serviceId: item.sD_Service_TId,
                    subCatId: item.newSubCat
                    
                });
            }
            else {
                if(!item.isChecked)
                this.servicesWizardService.selectedServiceList = _.reject(
                    this.servicesWizardService.selectedServiceList,
                    function (d) { return d.serviceId === item.sD_Service_TId; });
            }
        }

        isRequired(item: any): boolean {
            if (Model.Guard.isSomething(item.serviceWizardItems))
                for (var i = 0; i < item.serviceWizardItems.length; i++) {
                    if (item.serviceWizardItems[i].isChecked) {
                        return true;
                    }
                }
            return false;
        }

        

        selectedServiceSubCat(item: any): void {
            if (Model.Guard.isNothing(this.servicesWizardService.selectedServiceList)) {
                this.servicesWizardService.selectedServiceList = [];
            }
            if (item.isChecked) {
                this.servicesWizardService.selectedServiceList.push({
                    serviceId: item.sD_Service_TId,
                    subCatId: item.newSubCat.id

                });
            }
            else {
                this.servicesWizardService.selectedServiceList = _.reject(
                    this.servicesWizardService.selectedServiceList,
                    function (d) { return d.serviceId === item.sD_Service_TId; });
            }
        }


        selectAll(item: any):void {

        }

        allServicesforCatImported(catItems: any): boolean {

            for (var i = 0; i < catItems.length; i++) {
                if (!this.isServiceAlreadyImported(catItems[i]))
                    return false;
            }
            return true;
        }
      
    }

    angular.module('meevo.plugins.servicesWizard')
        .component('meevoServicesTabComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/servicesWizard/optionTabs/tabs/services/services-tab.component.html',
            controller: MeevoServicesTabComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<'
            }
        });
}



